  const selectElementBirth = document.querySelector("#birthday");
  const selectElementRegisterForm = document.querySelector("#customer-register");
  const selectElementRegisterFormButton = document.querySelector("#customer-register .btn");
  const selectElementEmail = selectElementRegisterForm.querySelector("#customer-email");
  
  selectElementBirth.addEventListener("change", (event) => {
    var birthdayDate = selectElementBirth.value;
    var emailRegister = selectElementEmail.value;
  });

  selectElementEmail.addEventListener("change", (event) => {
    var emailRegister = selectElementEmail.value;
  });

  var klaviyo= window.klaviyo || [];
  selectElementRegisterFormButton.addEventListener("click", function() {

    var birthdayDate = selectElementBirth.value;
    var emailRegister = selectElementEmail.value;
  
    klaviyo.identify({
       $email: emailRegister,
        Birthday: birthdayDate
    });
   return true;
          
})
